import { motion } from 'framer-motion';

const STEPS = [
  {
    num: '1',
    title: 'Reach Out',
    desc: 'Fill out our quick contact form or give us a call. We respond within 24 hours.',
  },
  {
    num: '2',
    title: 'Site Assessment',
    desc: 'We visit your location to find the perfect spot and recommend the right machine.',
  },
  {
    num: '3',
    title: 'Machine Placed',
    desc: 'We deliver, install, and stock your machine completely free of charge.',
  },
  {
    num: '4',
    title: 'Sit Back',
    desc: 'We handle restocking and maintenance. You enjoy the convenience. Simple.',
  },
];

const sectionVariants = {
  hidden: { opacity: 0, y: 18 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

const staggerContainer = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12 } },
};

const stepVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
};

export const HowItWorks = () => {
  return (
    <section
      id="how-it-works"
      className="scroll-mt-24 relative py-16 sm:py-24 noise"
      style={{
        background: 'radial-gradient(1000px circle at 30% 50%, rgba(214,178,76,0.06), transparent 50%), #0B0B0C',
      }}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <motion.div
          variants={sectionVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.25 }}
          className="text-center mb-12 sm:mb-16"
        >
          <span className="text-xs uppercase tracking-[0.22em] text-kv-gold font-sans font-semibold mb-4 block">
            How It Works
          </span>
          <h2 className="text-3xl sm:text-4xl font-display tracking-tight text-white">
            Four Simple Steps
          </h2>
        </motion.div>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8"
        >
          {STEPS.map((step) => (
            <motion.div
              key={step.num}
              variants={stepVariants}
              className="flex flex-col items-center text-center"
            >
              <div className="step-circle mb-5">{step.num}</div>
              <h3 className="text-lg font-display text-white mb-3">{step.title}</h3>
              <p className="text-sm text-white/50 leading-relaxed font-sans max-w-xs">{step.desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
